// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
/*#region Text*/
/*#endregion */
/*#region Elements*/
/**#region Event Container */
/*#endregion*/
/*#endregion */
/* #region Screen */
/* #endregion*/
:host {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 6px;
}

.filter-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-sizing: border-box;
  width: 200px;
  max-width: 200px;
  min-width: 200px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #3b5873;
  color: #9dbcda;
  font-size: 14px;
  line-height: 1.2;
  text-align: left;
  cursor: pointer;
  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;
}
@media (max-width: 1079px) {
  .filter-trigger {
    width: 180px;
    max-width: 180px;
    min-width: 180px;
  }
}
@media (max-width: 599px) {
  .filter-trigger {
    width: 238px;
    max-width: 238px;
    min-width: 238px;
  }
}
.filter-trigger:hover:not(:disabled) {
  background: rgb(25.8498985801%, 38.5557809331%, 50.3853955375%);
  border-color: rgba(157, 188, 218, 0.25);
}
.filter-trigger:focus-visible {
  outline: 2px solid #52aaff;
  outline-offset: 2px;
}
.filter-trigger.open {
  border-color: rgba(157, 188, 218, 0.45);
}
.filter-trigger.open .filter-trigger__chevron {
  transform: rotate(180deg);
}
.filter-trigger:disabled {
  background: #3f5061;
  color: #607387;
  cursor: not-allowed;
}
.filter-trigger.date {
  width: 168px;
  max-width: 168px;
  min-width: 168px;
}
.filter-trigger.category {
  width: 210px;
  max-width: 210px;
  min-width: 210px;
}

.filter-trigger__label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filter-trigger__chevron {
  flex: 0 0 auto;
  display: block;
  transition: transform 160ms ease;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
